import { NICmsContentComponent } from '@icms/core/content';

/**
 * Block content interface
 */
export interface IProductViewLayoutContent extends NICmsContentComponent.IData {
    /**
     * Whitelisted media roles
     */
    requiredMediaLabels?: string;
    /**
     * Disallowed media roles
     */
    bannedMediaLabels?: string;
    /**
     * Price note
     */
    priceNote?: string;
    /**
     * Delivery info
     */
    delivery_info?: string;
    /**
     * List of gallery slots (non mobile only)
     */
    galleryRows?: {
        layout: EMediaRowLayout;
    }[];
    /*
     * USP Block Variant
     */
    usp_block_variant?: 'Furniture' | 'Fashion' | 'Accessories';
    /**
     * Product details attributes to display
     */
    detailsAttributes: IProductGeneralDetailsGroupData[];
    /**
     * Return details
     */
    returnNote?: string;
    returnLinkText?: string;
    returnLink?: string;
    /**
     * Gift boxing
     */
    gift_boxing?: IGiftCopy[];
    gift_boxing_image?: string;
    /**
     * Bottom components list
     */
    bottomComponents: NICmsContentComponent.IData[];
    /**
     * Detail carousel
     */
    detail_carousel_enabled: boolean;
    detail_carousel_title?: string;
    detail_carousel_labels?: string;
    /**
     * Additional
     */
    allow_financing_tray: boolean;
    /** Transparent background */
    headerTransparent?: boolean;
    /** White text color */
    headerLightMode?: boolean;
}

export interface IMediaRow {
    ratio?: string;
    colspan?: number;
    image?: string;
    video?: string;
    position: number;
    labels?: string[];
    uid?: string;
    sizes?: string[];
    isComponentContainer?: boolean;
}

/**
 * Media row layout
 */
export enum EMediaRowLayout {
    portraitsPair,
    landscape
}

export interface IProductGeneralDetailsGroupData {
    heading: string;
    bulletpoints?: boolean;
    attributes: IProductGeneralDetailsAttributeData[];
}

export interface IProductGeneralDetailsAttributeData {
    type: 'attribute' | 'property';
    code?: string;
    code_manual?: string;
    bulletpoints: boolean;
    mode: EProductGeneralDetailsAttributeMode;
}

export interface IGiftCopy {
    gift_copy?: string;
}

export enum EProductGeneralDetailsAttributeMode {
    cms = 'cms',
    attributeTitleValue = 'attributeTitleValue',
    attributeValue = 'attributeValue'
}

export type TSidebar = 'details' | 'reviews' | 'klarna' | 'gift-boxing' | 'delivery' | 'size-guide' | 'xnotif' | 'how-to-measure';

export interface IProductSidebar {
    title: string;
    sidebar: TSidebar;
}

/**
 * Options that are presented with a swatch
 */
export const SWATCH_TYPE_OPTIONS = ['color', 'letter', 'scent'];
